/* eslint-disable import/no-unresolved,react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { SecurityTOTPBodyLayout } from 'assets/components';

const SecurityResetTOTPSecret = () => {
  const { t: translate } = useTranslation();

  const { state } = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (!state?.email && !state?.username) {
      history.push('/onboarding/login');
    }
  }, []);

  const renderButtons = () => (
    <button
      className="btn btn-primary w-100 text-bold"
      type="button"
      onClick={() =>
        history.push(`totp-reset-secret`, {
          ...state,
          resetSecretKey: true,
        })
      }>
      {translate('totp_warning_reset_secret_btn_label')}
    </button>
  );

  return (
    <SecurityTOTPBodyLayout
      title={translate('totp_warning_reset_secret_title')}
      renderButtons={renderButtons}
      withBack
      onPrevClick={history.goBack}>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <div className="text-center mt-4 mb-md-2">
          <img className="w-100" src="./assets/images/warning.png" alt="Success" />
        </div>
        <p className="text-dark text-center text-bold text-f5 mt-4">
          {translate('totp_warning_reset_secret_note')}
        </p>
        <p className="text-shadow text-center text-f5 mt-3">
          {translate('totp_warning_reset_secret_note_2')}
        </p>
      </div>
    </SecurityTOTPBodyLayout>
  );
};

export default SecurityResetTOTPSecret;
